import { AnaliseGrauExposicaoRisco } from '@/types/analise/AnaliseGrauExposicaoRisco';

export type AnaliseGrauExposicaoRiscoNome =
  'Crítico' | 'Elevado' | 'Moderado' | 'Baixo' | 'Inexpressivo';

export const GRAU_EXPOSICAO_RISCO_NOMES: Record<
  AnaliseGrauExposicaoRisco,
  AnaliseGrauExposicaoRiscoNome
> = {
  CRITICO: 'Crítico',
  ELEVADO: 'Elevado',
  MODERADO: 'Moderado',
  BAIXO: 'Baixo',
  INEXPRESSIVO: 'Inexpressivo',
};

export const GRAU_EXPOSICAO_RISCO_CHAVES = Object.fromEntries(
  Object.entries(GRAU_EXPOSICAO_RISCO_NOMES).map(([chave, valor]) => [valor, chave]),
) as Record<AnaliseGrauExposicaoRiscoNome, AnaliseGrauExposicaoRisco>;

export const GRAU_EXPOSICAO_RISCO_CORES: Record<AnaliseGrauExposicaoRisco, string> = {
  CRITICO: '#E03131',
  ELEVADO: '#F08C00',
  MODERADO: '#E4C23F',
  BAIXO: '#2F9E44',
  INEXPRESSIVO: '#8189A6',
};
